import http from './api'
import roomsService from './roomsService'

export interface CreateInvitationData {
  roomId: string
  recipientEmail: string
  role?: string
  kind?: 'room'
  /** Football rooms only, manager-only: head-start points applied on accept. */
  startingPoints?: number
  /** Current app origin so invite emails land on Academ, not Break Room Cup. */
  origin?: string
}

export interface InvitationPreview {
  token: string
  kind?: string
  status: string
  expired: boolean
  recipientEmail: string
  senderName: string
  roomName: string
}

class InvitationService {
  async createInvitation(data: CreateInvitationData): Promise<any> {
    const response = await http.post('/invitations', data)
    return response.data
  }

  async getInvitations(): Promise<any[]> {
    const response = await http.get('/invitations')
    return response.data
  }

  async getPreview(token: string): Promise<InvitationPreview> {
    const response = await http.get(`/invitations/preview/${encodeURIComponent(token)}`)
    return response.data
  }

  async markInvitationsAsRead(): Promise<any> {
    const response = await http.get('/invitations/read-all')
    return response.data
  }

  async updateInvitation(invitationId: string, status: string): Promise<any> {
    console.log('Updating invitation:', { invitationId, status })
    const response = await http.patch(`/invitations/${invitationId}`, { status })
    return response.data
  }

  async acceptInvitation(invitationId: string): Promise<any> {
    const result = await this.updateInvitation(invitationId, 'accepted')
    // Accept joins the room server-side; clear client list cache or getUserRooms() returns stale data for ~1 min
    roomsService.invalidateUserRoomsCache()
    return result
  }

  async declineInvitation(invitationId: string): Promise<any> {
    return this.updateInvitation(invitationId, 'rejected')
  }
}

const invitationService = new InvitationService()
export default invitationService
